import { NOT_APPLICABLE_LABEL } from '@/constants';
import { abyssColors } from '@/theme/colors';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton, Menu, MenuItem, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useSetAtom } from 'jotai';
import { Container, DateText, Title } from './style';
import { MouseEvent } from 'react';
import { openState, selectedCommentId, selectedCommentText } from '../state/atoms';

type Props = {
  createdAt: string;
  text: string;
  title?: string | null | undefined;
  id: string;
};

const CommentDisplay = ({ createdAt, title, text, id }: Props) => {
  const [expanded, setExpanded] = useState(false);
  const setDialogOpen = useSetAtom(openState);
  const setSelectedComment = useSetAtom(selectedCommentId);
  const setselectedCommentText = useSetAtom(selectedCommentText);
  const [anchorElement, setAnchorElement] = useState<null | HTMLElement>(null);

  const open = Boolean(anchorElement);
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorElement(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorElement(null);
  };

  const triggerEdit = () => {
    setSelectedComment(id);
    setselectedCommentText(text);
    setDialogOpen(true);
    handleClose();
  };

  const truncatedText = text.length > 250 && !expanded ? `${text.slice(0, 250)}` : text;

  return (
    <Container>
      <Stack width="100%">
        <Stack direction="row" alignItems="start" justifyContent="space-between" width="100%">
          <Title
            color={abyssColors.primary[700]}
            fontWeight={600}
            fontSize="1.4rem"
          >{`${title}:`}</Title>
          <Box>
            <IconButton
              aria-label="more"
              id="more-button"
              aria-controls={open ? 'more-button' : undefined}
              aria-expanded={open ? 'true' : undefined}
              aria-haspopup="true"
              onClick={handleClick}
              disableRipple
              sx={{ padding: 0 }}
            >
              <MoreVertIcon
                sx={{
                  margin: 0,
                  fontSize: '1.6rem',
                  color: abyssColors.primary[500],
                }}
              />
            </IconButton>
            <Menu
              anchorEl={anchorElement}
              open={open}
              onClose={handleClose}
              sx={{
                '& .MuiMenu-list': {
                  padding: '0.4rem 0',
                  borderRadius: '0.4rem',
                },
                '& .MuiMenu-paper': {
                  boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.30)',
                  marginTop: '0.8rem',
                },
              }}
            >
              <MenuItem
                sx={{
                  minWidth: '15rem',
                  fontSize: '1.2rem',
                  color: abyssColors.primary[500],
                  lineHeight: 'normal',
                  height: 'fit-content',
                  padding: '0.4rem 1.6rem',
                }}
                onClick={triggerEdit}
              >
                Edit
              </MenuItem>
            </Menu>
          </Box>
        </Stack>
        <DateText>{createdAt}</DateText>
        <Title
          sx={{ fontSize: '1.6rem', color: abyssColors.primary[400], lineHeight: '150%' }}
        >{`“${truncatedText || NOT_APPLICABLE_LABEL}”.`}</Title>
        {text.length > 264 && (
          <Typography
            sx={{
              color: '#00E',
              fontSize: '1.6rem',
              cursor: 'pointer',
              marginTop: '0.4rem',
              letterSpacing: '0.015rem',
              textDecoration: 'underline',
            }}
            onClick={() => setExpanded(!expanded)}
          >
            {expanded ? 'show less' : 'see full comment'}
          </Typography>
        )}
      </Stack>
    </Container>
  );
};

export default CommentDisplay;
